module.exports = __webpack_public_path__ + "img/comercam-mezcal.a2106ad2.jpg";